module.exports = __webpack_public_path__ + "static/media/kerstman-door-het-ijs-2.dda5446d.jpeg";